/*
	Abre ou Fecha o menu (reverte o estado)
*/
export default (state) => 
	state.aside.isOpen = !state.aside.isOpen
